<template>
  <div
    class="cycles-page-header d-flex justify-space-between align-start"
    data-testid="bookclosure-project-list__header"
  >
    <div class="cycles-page-header__left">
      <div
        class="cycles-page-header__title-group d-flex align-center"
        data-testid="cycles-page__title-group"
      >
        <h3
          class="cycles-page-header__title ma-0"
          data-testid="cycles-page__title"
        >
          Cycles
        </h3>
        <v-tooltip bottom content-class="tooltip-bottom" open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              small
              class="shadow-off"
              :disabled="loading"
              :loading="loading"
              data-testid="bookclosure-project-list__refresh-btn"
              @click="$emit('refresh')"
            >
              <img src="/img/icons/fbc-icons/RefreshIcon.svg" alt="Refresh" class="cycles-page-header__refresh-icon">
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>
      </div>
      <p
        class="cycles-page-header__description mt-2 noTransform"
        data-testid="cycles-page__description"
      >
        Manage and monitor your financial close cycles across all periods and locations.
      </p>
    </div>

    <div
      class="cycles-page-header__actions d-flex align-center"
      data-testid="bookclosure-project-list__actions"
    >
      <v-tooltip
        v-if="canAdd && showAddButton"
        bottom
        content-class="tooltip-bottom"
        open-delay="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            color="primary"
            class="cycles-page-header__add-btn text-none"
            :disabled="loading"
            data-testid="bookclosure-project-list__add-cycle-btn"
            @click="$emit('add-cycle')"
          >
            <v-icon left small data-testid="bookclosure-project-list__add-cycle-icon">mdi-plus</v-icon>
            Add Cycle
          </v-btn>
        </template>
        <span>Add Cycle</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import './CyclesPageHeader.scss';

export default {
  name: 'CyclesPageHeader',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    canAdd: {
      type: Boolean,
      default: false,
    },
    /** Hide header CTA when true-empty state owns the Add Cycle button. */
    showAddButton: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
